if(!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.elForm = this.querySelector("form");
      this.elSellingPlans = this.querySelectorAll('input[name="selling_plan"]');
      this.elVariants = this.querySelectorAll('input[name="id"]');
      this.elPrice = this.querySelectorAll('[data-price]');
      this.elCap = this.querySelectorAll('[data-cap]');
      this.elCartPrice = this.querySelector('[data-cart-price]');
      this.elCartCap = this.querySelector('[data-cart-cap]');
      this.elSubheading = this.querySelectorAll('[data-subheading]');
      this.elSubmit = this.elForm.querySelector('button[type="submit"]');
      this.elSubmitCta = this.elSubmit.querySelector('[data-cta]');
      this.elStatus = this.querySelector('[data-status]');

      this.promotion = this.getAttribute('promotion');

      this.url = new URL(window.location);
      this.shouldUpdateUrl = this.getAttribute('update-url') == "true";

      this.cartData = {};
      this.setCartData();

      this.elForm.addEventListener('change', this.onFormChange.bind(this));
      this.elForm.addEventListener('submit', this.addToCart.bind(this));
    }

    onFormChange({ target }) {
      this.setCartData();
      this.updatePrices(target, target.name);
      this.updateSubheading(target);
      this.shouldUpdateUrl && this.updateURL();
      target.name == 'selling_plan' && this.updateVariantInputs(target);
    }

    setCartData() {
      const elCurrentVariant = [...this.elVariants].find(el => el.checked);
      const elSellingPlan = this.elSellingPlans.length ? [...this.elSellingPlans].find(el => el.checked) || null : null;

      const sellingPlan = elSellingPlan.value == 'null' ? null : Number(elSellingPlan.value);

      this.cartData = {
        id: Number(elCurrentVariant.value),
        quantity: 1,
        ...(sellingPlan && { selling_plan: sellingPlan } ),
        ...(this.promotion && { properties: { '_promotion': this.promotion } } )
      }

      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: {
          variant: {
            id: Number(elCurrentVariant.value),
            title: elCurrentVariant.getAttribute('data-variant-title')
          },
          sellingPlan: {
            id: sellingPlan,
            title: elSellingPlan.getAttribute('data-label')
          } 
        }
      }))
    }

    updateVariantInputs(elInput) {
      if(this.elVariants.length > 1) {
        const elSellingPlan = elInput.closest('[data-selling-plan]');
        this.elVariants.forEach(el => {
          const isChildOfSellingPlan = el.closest('[data-selling-plan]') == elSellingPlan;
          el.checked = isChildOfSellingPlan && el.value == this.cartData.id;
          el.disabled = !isChildOfSellingPlan
        })
      }
    }

    updatePrices(elInput, name) {
      const elVariant = name == 'selling_plan' ? elInput.closest('[data-selling-plan]').querySelector(`input[name="id"][value="${this.cartData.id}"]`) : elInput;
      const { variantPrice: cartPrice, variantCap: cartCap, variantAvailable: available } = elVariant.dataset;

      this.elCartPrice.innerHTML = cartPrice;
      this.elCartCap.innerHTML = cartCap;

      this.elSubmit.disabled = available != 'true';
      this.elSubmitCta.innerHTML = available == 'true' ? 'Add to Cart' : 'Sold Out';

      this.elSellingPlans.forEach(el => {
        const elSellingPlan = el.closest('[data-selling-plan]');
        const elSellingPlanVariant = elSellingPlan.querySelector(`input[name="id"][value="${this.cartData.id}"]`);
        const elPrice = elSellingPlan.querySelector('[data-price]');
        const elCap = elSellingPlan.querySelector('[data-cap]');
        const { variantPrice, variantCap } = elSellingPlanVariant.dataset;

        elPrice && (elPrice.innerHTML = variantPrice);
        elCap && (elCap.innerHTML = variantCap);
      })
    }

    updateURL() {
      const { selling_plan, id: variantId } = this.cartData;
      this.url.searchParams.set('variant', variantId);
      selling_plan ? this.url.searchParams.set('selling_plan', selling_plan) : this.url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', this.url);
    }

    updateSubheading(elInput) {
      const subheading = elInput.getAttribute('data-variant-subheading');
      if(subheading) {
        this.elSubheading.forEach(el => {
          el.innerHTML = subheading;
        })
      }
    }

    addToCart(ev) {
      ev.preventDefault();
      this.classList.add("adding");
      this.elStatus.innerHTML = `<span>Adding <span class="visually-hidden">to cart</span>...</span>`;
      this.elSubmit.disabled = true;

      window.addToCart(this.cartData)
        .then((response) => {
          this.classList.remove("adding");
          if (response.status) {
            this.classList.add("error");
            this.elStatus.innerHTML = `<span>Error<span class="visually-hidden"> adding to cart</span></span>`;
          } else {
            this.classList.add("success");
            this.elStatus.innerHTML = `<span>Added to cart</span>`;
          }
          setTimeout(() => this.resetState(), 5000);
        });
    }

    resetState() {
      this.classList.remove("error");
      this.classList.remove("success");
      this.elSubmit.disabled = false;
      setTimeout(() => {
        this.elStatus.innerHTML = "";
      }, 300);
    }
  }

  customElements.define('product-form', ProductForm);
}